import React, {useState} from 'react';
import {useNavigate} from "react-router-dom";
import {Alert, Button, Form} from 'react-bootstrap';
import {Link} from "react-router-dom";

import AuthService from "../../services/auth.service";
import {withRouter} from '../../common/with-router';

import validator from 'validator'
import pfLogo from '../../img/social-logo.png';
import '../../Auth.css';
import {API_EDITS_ALLOWED} from "../../services/axios.utils";


const Register = () => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [roles, setRoles] = useState([]); // eslint-disable-line no-unused-vars
    const [waiver, setWaiver] = useState(false);
    const [errors, setErrors] = useState({});

    const navigate = useNavigate();

    let editsAllowed = API_EDITS_ALLOWED === "true"

    const validateForm = () => {
        const newErrors = {};
        if (!name) {
            newErrors.name = 'Name is required';
        }
        else if (name.length < 4) {
            newErrors.name = 'Name must be at least 4 characters';
        }

        if (!email) {
            newErrors.email = 'Email is required';
        }
        else if (!/\S+@\S+\.\S+/.test(email)) {
            newErrors.email = 'Email is invalid';
        }

        if (!password) {
            newErrors.password = 'Password is required';
        }
        else if (!validator.isStrongPassword(password, {
            minLength: 8,
            minLowercase: 1,
            minUppercase: 1,
            // minNumbers: 1,
            minSymbols: 1
        })) {
            newErrors.password = 'Password must be at least 8 characters long, ' +
                'with at least: 1 lower case letter, 1 upper case letter, 1 number, 1 symbol';
        }

        if (!roles || roles.length === 0) {
            newErrors.roles = 'At least one role is required';
        }

        if (!waiver || waiver.length === 0) {
            newErrors.waiver = 'You have to agree to the terms of the Winchester Porchfest';
        }

        return newErrors;
    };

    const appendRole = (r) => {
        if (!roles.includes(r)) {
            roles.push(r);
        }
    }

    const removeRole = (r) => {
        if (roles.includes(r)) {
            const i = roles.indexOf(r);
            roles.splice(i, 1);
        }
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        const formErrors = validateForm();
        if (Object.keys(formErrors).length > 0) {
            setErrors(formErrors);
        } else {
            setErrors({});
            console.log("roles:" + JSON.stringify(roles));
            AuthService.register(name, email, password, roles).then(
                () => {
                    navigate("/profile");
                    window.location.reload();
                },
                error => {
                    const newErrors = {};
                    newErrors.authentication = error.response.data.error
                    setErrors(newErrors);
                }
            )
        }
    };

    return (
        <div className="auth-wrapper">
            <div className="auth-form-container">
                {!editsAllowed &&
                    <Alert variant="danger">
                        Registration is closed for Porchfest 2025.
                    </Alert>
                }
                <h2 className="auth-title">
                    <img src={pfLogo}
                         alt="Winchester Porchfest"
                         title="Winchester Porchfest"
                         // height="20px"
                         className="profile-img-card"/>
                </h2>
                {editsAllowed &&
                    <Alert variant="info">
                        Who should register? See our <Link to="/faq" reloadDocument="true">FAQ page</Link>.
                    </Alert>
                }

                <Form.Group>
                    <Form onSubmit={handleSubmit} className="auth-form">

                        <Form.Group className="mb-3">
                            <Form.Label column={true}>Full name:</Form.Label>
                            <Form.Control
                                type="name"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                isInvalid={!!errors.name}
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors.name}
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label column={true}>Email address:</Form.Label>
                            <Form.Control
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                isInvalid={!!errors.email}
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors.email}
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label column={true}>Password:</Form.Label>
                            <Form.Control
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                isInvalid={!!errors.password}
                            />
                            <span className="text-muted, small">Min 8 characters, 1 upper case character, 1 symbol</span>
                            <Form.Control.Feedback type="invalid">
                                {errors.password}
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label column={true}>I would like to register as a:</Form.Label>
                            <Form.Check
                                type="checkbox"
                                id="role-host"
                                label="Host: I have a venue that can host acts"
                                onChange={(e) => {
                                    if (e.target.checked) {
                                        appendRole("host")
                                    } else {
                                        removeRole("host")
                                    }
                                }}
                                isInvalid={!!errors.roles}
                            />
                            <Form.Check
                                type="checkbox"
                                id="role-performer"
                                label="Performer: I am an act looking for a venue"
                                onChange={(e) => {
                                    if (e.target.checked) {
                                        appendRole("performer")
                                    } else {
                                        removeRole("performer")
                                    }
                                }}
                                isInvalid={!!errors.roles}
                            />
                            {errors && errors.roles &&
                                <div className="invalid-checkbox-feedback">
                                    At least one role is required
                                </div>
                            }
                            <span className="text-muted, small">
                                Note: If you are a self-hosting performer, please select both Host and Performer options above.
                            </span>
                            <br/>
                            <br/>

                            <Form.Check
                                type="checkbox"
                                id="waiver-check"
                                label={
                                    <span className="text-muted, small">I certify that I have read, fully understood, and agreed to
                                        the <Link to={"/waivers"} reloadDocument="true" target="_blank" rel="noopener noreferrer">Winchester Porchfest Liability Waivers</Link>.
                                         I agree to be photographed and or filmed, and agree that I am participating at my own risk and will hold performers, hosts, volunteers, and/or organizers free of any liability and/or claim for damages in the event of disappointment, accident, or injury.
                                    </span>
                                }
                                onChange={(e) => {
                                    if (e.target.checked) {
                                        setWaiver(true);
                                    } else {
                                        setWaiver(false);
                                    }
                                }}
                                isInvalid={!!errors.waiver}
                            />
                            {errors && errors.waiver &&
                                <div className="invalid-checkbox-feedback">
                                    You have to agree to the Winchester Porchfest Liability Waivers
                                </div>
                            }
                        </Form.Group>

                        <Button variant="primary" type="submit" className="auth-button" disabled={!editsAllowed}>
                            Register
                        </Button>

                        {errors && errors.authentication &&
                            <div>
                                <br/>
                                <Alert variant="danger">{errors.authentication}</Alert>
                            </div>
                        }
                        <div className="auth-alt">
                            Already a member?&nbsp;<Link to={"/login"} reloadDocument="true">Login</Link>
                        </div>
                    </Form>
                </Form.Group>
            </div>
        </div>
    );
}

export default withRouter(Register);